module.exports = __webpack_public_path__ + "img/serve_07@2x.4240ec10.png";